import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

interface IMenuItem {
  type: string; // Possible values: link/dropDown/icon/separator/extLink
  name?: string; // Used as display text for item and title for separator type
  state?: string; // Router state
  icon?: string; // Material icon name
  tooltip?: string; // Tooltip text
  disabled?: boolean; // If true, item will not be appeared in sidenav.
  sub?: IChildItem[]; // Dropdown items
  badges?: IBadge[];
}
interface IChildItem {
  type?: string;
  name: string; // Display text
  state?: string; // Router state
  icon?: string;
  sub?: IChildItem[];
}

interface IBadge {
  color: string; // primary/accent/warn/hex color codes(#fff000)
  value: string; // Display text
}

@Injectable()
export class NavigationService {
  constructor() {}
  iconMenu: IMenuItem[] = [
    {
      name: "HOME",
      type: "icon",
      tooltip: "Home",
      icon: "home",
      state: "home"
    },
    {
      type: "separator",
      name: "Main Items"
    },
    {
      name: "DASHBOARD",
      type: "dropDown",
      tooltip: "Dashboard",
      icon: "dashboard",
      state: "dashboard",
      sub: [{ name: "Default", state: "default" }]
    },
    {
      name: "User Table",
      type: "link",
      tooltip: "User Table",
      icon: "format_list_bulleted",
      state: "cruds-user/crud-user-table"
    },
    {
      name: "Blog",
      type: "link",
      tooltip: "Blog",
      icon: "inbox",
      state: "blog"
    }
  ];

  adminMenu: IMenuItem[] = [
    {
      type: "separator",
      name: "Admin Menu Items"
    },
    {
      name: "DASHBOARD",
      type: "link",
      tooltip: "Dashboard",
      icon: "dashboard",
      state: "dashboard/default"
    },
    {
      name: "User Table",
      type: "link",
      tooltip: "User Table",
      icon: "format_list_bulleted",
      state: "cruds-user/crud-user-table"
    },
    {
      name: "Blog",
      type: "link",
      tooltip: "Blog",
      icon: "inbox",
      state: "blog"
    }
  ];

  plainMenu: IMenuItem[] = [
    {
      name: "DASHBOARD",
      type: "link",
      tooltip: "Dashboard",
      icon: "dashboard",
      state: "dashboard"
    },
    {
      name: "BLOG",
      type: "link",
      tooltip: "Blog",
      icon: "inbox",
      state: "blog"
    }
  ];

  userMenu: IMenuItem[] = [
    {
      type: "separator",
      name: "Member Menu Items"
    },
    {
      name: "Blogs",
      type: "link",
      tooltip: "Blog",
      icon: "inbox",
      // state is title
      state: "blog-cards"
    },
    {
      name: "Youtube",
      type: "link",
      tooltip: "Vlog",
      icon: "camera",
      state: "youtube-channel"
    },
    {
         name: "Exclusive Service",
         type: "link",
         tooltip: "Shop",
         icon: "shopping_cart",
         state: "shop",
      //   sub: [
      //      { name: "PRODUCTS", state: "" },
      //      { name: "PRODUCT DETAILS", state: "products/5a9ae2106f155194e5c95d67" },
      //      { name: "CART", state: "cart" },
      // //     { name: "CHECKOUT", state: "checkout" }
      //    ]
       },
  ];

  // Icon menu TITLE at the very top of navigation.
  // This title will appear if any icon type item is present in menu.
  iconTypeMenuTitle: string = "Frequently Accessed";

  // sets  default menu;
  //// user menu /////
  //menuItemsforUsers = new BehaviorSubject<IMenuItem[]>(this.userMenu);
  // navigation component has subscribed to this Observable
  // menuItemsforUser$ = this.menuItemsforUsers.asObservable();
  //// admin menu /////
  menuItems = new BehaviorSubject<IMenuItem[]>(this.userMenu);
  // navigation component has subscribed to this Observable
  menuItems$ = this.menuItems.asObservable();

  // Customizer component uses this method to change menu.
  // You can remove this method and customizer component.
  // Or you can customize this method to supply different menu for
  // different user type.
  publishNavigationChange(menuType: string) {
    switch (menuType) {
      case "admin-menu":
        this.menuItems.next(this.adminMenu);
        break;
      case "user-menu":
        this.menuItems.next(this.userMenu);
        break;
      case "icon-menu":
        this.menuItems.next(this.iconMenu);
        break;
      default:
        this.menuItems.next(this.plainMenu);
    }
  }
}
